<script setup>
import { useLayout } from '@/layout/composables/layout';
import logoPath from '@/assets/images/logo-bold.svg'

const { toggleMenu, toggleDarkMode, isDarkTheme } = useLayout();
</script>

<template>
    <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" data-onboarding="nav-toggle" @click="toggleMenu">
                <i class="pi pi-bars"></i>
            </button>
            <router-link to="/" class="layout-topbar-logo">
                <img :src="logoPath" alt="SmartHOA Logo" width="30" height="30">
                <span>SmartHOA</span>
            </router-link>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <button type="button" class="layout-topbar-action" @click="toggleDarkMode">
                    <i :class="['pi', { 'pi-moon': isDarkTheme, 'pi-sun': !isDarkTheme }]"></i>
                </button>
            </div>
            <div class="layout-topbar-menu-content">
                <router-link to="/profile" type="button" class="layout-topbar-action" data-onboarding="nav-profile">
                    <i class="pi pi-user"></i>
                    <span>Profile</span>
                </router-link>
            </div>
        </div>
    </div>
</template>
